import React, { useState } from "react";
import FilterDropDown from "../../MaterialComponents/DropDownMenu/FilterDropDown";
import Search from "../Search/Search";
import { Button } from "@material-ui/core/";
import { store } from "../../../Store/store";

import "./ListFunctions.css";
import { COLORS } from "../../../Theme/variables";

let langData = require("../../../Data/language.json");

export default function ListFunctions(props) {
  const [expanded, setExpanded] = useState(false);
  let expandContainer = document.querySelector(".listFunctions");
  let mainScreenMode = store.getState().mainScreen.mainScreenMode;
  let title = langData[props.language][mainScreenMode].title;

  const handleSearchClick = () => {
    if (expanded) {
      setExpanded(false);
      expandContainer.style.height = "40px";
    } else {
      expandContainer.style.height = "100px";
      setExpanded(true);
    }
  };

  return (
    <div className="container-fluid col-12 listFunctions">
      <div className="row">
        <div className="container-fluid col-3 filterBtnContainer">
          <FilterDropDown language={props.language} />
        </div>
        <div className="container-fluid col-6 navigationTitle">
          <h4>{title}</h4>
        </div>
        <div className="container-fluid col-3 searchBtnContainer">
          <Button
            onClick={() => handleSearchClick()}
            variant="contained"
            style={
              expanded
                ? {
                    backgroundColor: "white",
                    border: `solid 2px ${COLORS.primary}`,
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  }
                : {
                    backgroundColor: "white",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    outline: "none",
                  }
            }
          >
            <img
              className="btnImage"
              style={{ color: "blue" }}
              src={require("../../../Images/Icons/searchIcon.svg")}
              alt="searchIcon"
            />
          </Button>
          {props.filter !== "" && <div id="activeSearchNotice" />}
        </div>
      </div>
      {expanded ? (
        <div className="row">
          <div className="container-fluid col-12 searchContainer">
            <Search
              onSearch={props.onSearch}
              language={props.language}
              filter={props.filter}
              emptyFilter={props.emptyFilter}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
